import { render, staticRenderFns } from "./notice_list.vue?vue&type=template&id=d18728a0&scoped=true&"
import script from "./notice_list.vue?vue&type=script&lang=js&"
export * from "./notice_list.vue?vue&type=script&lang=js&"
import style0 from "./notice_list.vue?vue&type=style&index=0&id=d18728a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18728a0",
  null
  
)

export default component.exports